import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICON } from '@core/util/icon';
import { BusinessClient, PersonClient } from '@models/clients';
import {
	Branch,
	FinancialInstitutionLender,
	Lender,
	MortgageeType,
} from '@models/lender';
import { ClientsRepoService } from '@repos/clients/clients.service';
import { LenderClientAssociation } from './client-lender-card/client-lender-card.component';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { MatterClients } from '@state/global/matter_clients';
import {
	BusinessMatterClientWithAssociations,
	PersonMatterClientWithAssociations,
} from '@models/matter';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
	selector: 'app-lender-card',
	templateUrl: './lender-card.component.html',
	standalone: false,
})
export class LenderCardComponent implements OnInit {
	@Input() lender: Lender;
	@Input() collapsed: boolean = false;
	@Input() primary: boolean = false;
	@Output() collapsedChange = new EventEmitter<boolean>();

	@Input() collapsable: boolean = false;
	@Input() highlightOnExpand: boolean = false;
	@Input() hideKebab: boolean = false;
	@Input() hideBranchSelector: boolean = false;
	@Input() hideContactDetails: boolean = false;

	@Output() onRemoveLender = new EventEmitter<void>();
	@Output() onRemoveInvestor = new EventEmitter<string>();
	@Output() onEditLender = new EventEmitter<Lender>();
	@Output() onAddAssociation = new EventEmitter<LenderClientAssociation>();
	@Output() onSetAsPrimary = new EventEmitter<string>();

	@Select(MatterClients.get_clientPrivateLendersWithAssociationMapped)
	privateLendersWithAssociations$: Observable<
		(
			| PersonMatterClientWithAssociations
			| BusinessMatterClientWithAssociations
		)[]
	>;
	@SelectSnapshot(MatterClients.get_investors) investorsWithAssociations: (
		| PersonMatterClientWithAssociations
		| BusinessMatterClientWithAssociations
	)[];

	public ICON = ICON;
	public clientData: PersonClient | BusinessClient;

	public mortgageeTypes = MortgageeType;
	public investorsDataMapping: {
		[key: string]:
			| PersonMatterClientWithAssociations
			| BusinessMatterClientWithAssociations;
	} = {};

	constructor(private clientRepo: ClientsRepoService) {}

	ngOnInit(): void {
		if (this.lender?.mortgageeType === MortgageeType.PRIVATE_LENDER) {
			this.privateLendersWithAssociations$
				.pipe(untilDestroyed(this))
				.subscribe((privateLendersWithAssociations) => {
					this.clientData = privateLendersWithAssociations.find(
						(lender) => lender.id === this.lender.clientId,
					);
				});
		}
	}

	onFinancialInstitutionRemove() {
		this.onRemoveLender.emit();
	}

	onFinancialInstitutionEdit(financialInstitution: FinancialInstitutionLender) {
		this.onEditLender.emit({
			...this.lender,
			...financialInstitution,
		});
	}

	onBranchAddedToFinancialInstitution(branch: Branch) {
		this.onFinancialInstitutionEdit({
			...this.lender,
			branch: branch,
		});
	}

	onBranchRemovedFromFinancialInstitution() {
		this.onFinancialInstitutionEdit({
			...this.lender,
			branch: null,
		});
	}

	onRemoveLenderClient() {
		this.onRemoveLender.emit();
	}
}
